import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase'

const SortByName = ({
  color = 'icon.primary',
  fill = 'transparent',
  ...props
}) => (
  <IconBase viewBox='0 0 18 20' {...props}>
    <Path
      d='M3.67578 18.3217L1.33597 15.9819'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M5.88379 16.1082L3.67442 18.3175'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M3.68457 1L3.68457 18.3153'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M11.0225 12.5385H15.8813L11.0225 18.3077H15.8813'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M16.3366 6.7692L13.452 1L10.5674 6.7692'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M11.0498 5.8047H15.8521'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconBase>
)

SortByName.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default SortByName
